import React, { FC, useEffect, useRef, useState } from 'react'
import lottie from 'lottie-web'
import styled from 'styled-components'

import fileTransferJson from '../../../assets/lotties/fileTransfer.json'
import aiJson from '../../../assets/lotties/ai.json'
import consultJson from '../../../assets/lotties/consult.json'
import loadSpinnerJson from '../../../assets/lotties/loading.json'
import emptyConsultationJson from '../../../assets/lotties/emptyConsultation.json'
import femaleAvatarJson from '../../../assets/lotties/femaleAvatar.json'
import maleAvatarJson from '../../../assets/lotties/maleAvatar.json'
import patientSearchJson from '../../../assets/lotties/patientSearch.json'
import patientSearchInProgressJson from '../../../assets/lotties/patientSearchInProgress.json'
import emptySearchJson from '../../../assets/lotties/emptySearch.json'
import confidenceLevelJson from '../../../assets/lotties/confidenceLevel.json'

export enum LottieAnimationName {
    FileTransfer = 'FileTransfer',
    AI = 'AI',
    Consult = 'Consult',
    LoadSpinner = 'LoadSpinner',
    EmptyConsultation = 'EmptyConsultation',
    FemaleAvatar = 'FemaleAvatar',
    MaleAvatar = 'MaleAvatar',
    PatientSearch = 'PatientSearch',
    PatientSearchInProgress = 'PatientSearchInProgress',
    EmptySearch = 'EmptySearch',
    ConfidenceLevel = 'ConfidenceLevel',
}

const animationJsonMap = {
    [LottieAnimationName.FileTransfer]: fileTransferJson,
    [LottieAnimationName.AI]: aiJson,
    [LottieAnimationName.Consult]: consultJson,
    [LottieAnimationName.LoadSpinner]: loadSpinnerJson,
    [LottieAnimationName.EmptyConsultation]: emptyConsultationJson,
    [LottieAnimationName.FemaleAvatar]: femaleAvatarJson,
    [LottieAnimationName.MaleAvatar]: maleAvatarJson,
    [LottieAnimationName.PatientSearch]: patientSearchJson,
    [LottieAnimationName.PatientSearchInProgress]: patientSearchInProgressJson,
    [LottieAnimationName.EmptySearch]: emptySearchJson,
    [LottieAnimationName.ConfidenceLevel]: confidenceLevelJson,
}

export const SvgContainer = styled.div<{
    $width?: string
    $height?: string
}>`
    width: ${(p) => p.$width ?? 'auto'};
    height: ${(p) => p.$height ?? 'auto'};
`

export interface Props {
    name: LottieAnimationName
    width?: string
    height?: string
    animate?: boolean
}

export const LottieAnimation: FC<Props> = ({
    name,
    width,
    height,
    animate = true,
}) => {
    const ref = useRef(null)

    useEffect(() => {
        if (!ref.current) return
        if (!(name in animationJsonMap)) return

        const animation = lottie.loadAnimation({
            container: ref.current,
            renderer: 'svg',
            loop: animate,
            autoplay: animate,
            animationData: animationJsonMap[name],
        })
        return () => animation.destroy()
    }, [ref?.current, name])

    return <SvgContainer ref={ref} $width={width} $height={height} />
}
